<template>
  <div style="width:100%;">
    <div class="container">
      <div>
        <div class="header">
          <el-image
            style="width:38px;height:38px;"
            :src="iconHeader"
          ></el-image>
          <span class="title_font" @click="goBack">{{ titleName }}</span>
        </div>
        <div class="title_line"></div>
        <template v-if="cellsectList.length">
          <div class="content" v-show="isContent">
            <ul>
              <li v-for="(item, index) in cellsectList" :key="index" class="t-h">
                <el-image
                  :src="item.csFmimg"
                  class="img"
                  @click="openDetail(item)"
                >
                  <div slot="error">
                    <el-image :src="defaultImg" @click="openDetail(item)">
                    </el-image></div
                ></el-image>
                <p @click="openDetail(item)">{{ item.csTitle }}</p>
              </li>
            </ul>
            <div style="text-align: center; margin-top: 8px">
              <el-pagination
                @current-change="handleCurrentChange"
                :page-size="pageParams.pageSize"
                layout="prev, pager, next"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
          <div class="content" v-show="!isContent">
            <div style="margin-bottom:20px;">
              <span>{{ details.csDigest }}</span>
            </div>
          </div>
        </template>
        
        <div v-else>
          <div style="font-size:18px;margin:20px 0;text-indent:44px;">敬请期待...</div>
        </div>
      </div>
    </div>
    <div style="width:100%;height:600px;" v-show="!isContent">
      <iframe
        key="processDrawingIframe"
        :src="iframeUrl"
        frameborder="0"
        align="left"
        width="100%"
        height="100%"
      >
        <p>你的浏览器不支持iframe标签</p>
      </iframe>
    </div>
  </div>
</template>

<script>
import { getCellsection, getCellsectDetail, getDictionary } from "@/network/api";
export default {
  data() {
    return {
      defaultImg: require("@/assets/images/defalut_icon.png"),
      iconHeader: require("@/assets/images/cells.png"),
      titleName: "细胞阅片",
      isContent: true,
      cellsectList: [],
      details: {},
      iframeUrl: '',
      total: 0,
      pageParams:{
        pageNum: 1,
        pageSize: 10
      }
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      let cellsectParams = {
        pageNum: this.pageParams.pageNum,
        pageSize: this.pageParams.pageSize
      };
      getCellsection(cellsectParams).then(res => {
        this.cellsectList = res.rows || [];
        this.total = res.total;
      });
    },
    openDetail(item) {
      this.titleName = `细胞阅片 / ${item.csTitle}【返回】`;
      this.isContent = false;
      getCellsectDetail(item.id).then(res => {
        this.details = res.data;
        this.iframeUrl = l_config.iframe + item.csPreview
        // getDictionary()
      });
    },
    goBack() {
      this.titleName = "细胞阅片";
      this.isContent = true;
    },
    handleCurrentChange(val) {
      this.pageParams.pageNum = val;
      this.initData();
    },
  }
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
}
.header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
  cursor: pointer;
}
.title_line {
  padding: 0;
  height: 1px;
  background-color: #b7b7b7;
  margin-bottom: 10px;
}
.content {
  width: 1150px;
}
ul,
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
ul {
  display: flex;
  height: auto;
  width: 100%;
  flex-flow: wrap;
}
li {
  width: 33%;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 10px 0 20px 0;
  font-size: 18px;
  font-weight: bold;
}
.img {
  /* width: 80%; */
  margin-bottom: 20px;
}
.t-h:hover {
  color: #397b3e;
  cursor: pointer;
}
.t-h:hover p {
  color: #397b3e;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/CellSection.vue